import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

class FHEContainerScroll extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        children: PropTypes.node.isRequired
    };

    render() {
        const { children, classes } = this.props;
        return <div className={classes.container}>{children}</div>;
    }
}

const styles = theme => ({
    container: {
        overflow: 'auto',
        marginRight: -50,
        paddingRight: 50,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('md')]: {
            marginRight: -30,
            paddingRight: 30
        },
        [theme.breakpoints.down('sm')]: {
            marginRight: -20,
            paddingRight: 20
        },
        [theme.breakpoints.down('xs')]: {
            marginRight: -10,
            paddingRight: 10
        }
    }
});

export default withStyles(styles, { withTheme: true })(FHEContainerScroll);



// WEBPACK FOOTER //
// ./data/components/FHEContainerScroll.js